import VueUploadComponent from 'vue-upload-component'
import Vue from 'vue'

Vue.component('vue-file-upload', VueUploadComponent)
